<div
  class="footer"
  appScrollSync
  [sourceName]=`${resourceParamsKey}-footer`
  [syncGroup]="resourceParamsKey"
>
  @for (columnParam of columnParamsStateService.getColumnParamsByKey(resourceParamsKey); track columnParam.key; let index = $index) {
    @if (isNeedCheckbox(index)) {
      <div class="table-cell footer-cell sticky"></div>
    }
    @if (isColumnDisplayed(columnParam)) {
      <div
        #footerCell
        class="table-cell footer-cell"
        [attr.data-column]="columnParam.key"
        [style.left.px]="columnParam.leftPositionForStickyColumn"
        [style.max-width.px]="getWidth(columnParam)"
        [style.min-width.px]="getWidth(columnParam)"
        [class]="{
          'with-background': columnParam.enableBackgroundColour,
          'sticky': columnParam.sticky
        }"
      >
        @if (!!getColumnTotalParams(columnParam.key)) {
          <div
            [matTooltip]="getDescriptionRecordTotal(columnParam.key)"
            matTooltipClass
          >
            {{ getTranscriptRecordTotalType(columnParam.key)! }}:
            {{ recordTotalValue }}
          </div>
        }
      </div>
    }
    @if (columnParam.separated) {
      <div class="separator-column"></div>
    }
    @if (columnParam.hiddenGroupPlaceholder) {
      <div
        class="hidden-group-placeholder hidden-group-footer"
        app-hidden-group
        [resourceParamsKey]="resourceParamsKey"
        [columnParams]="columnParam"
      ></div>
    }
  }

  @if (isAnyTableActionAvailable) {
    <div class="footer-cell table-action"></div>
  }
</div>
